
export const KEEP_ALIVE = 'keep-alive'
